/**
 * SEO component using react-helmet-async.
 * Manages <title>, meta description, canonical, and Open Graph tags.
 */
import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Strategic Tracking";
const DEFAULT_OG = "/og-default.png";

export default function Seo({
  title,
  absoluteTitle = false,
  description,
  canonical,
  ogImage,
  ogType = "website",
  noindex = false,
  jsonLd,
}) {
  const fullTitle = title
    ? (absoluteTitle ? title : `${title} | ${SITE_NAME}`)
    : `${SITE_NAME} | Tracking Solution Directory`;
  const desc = description ||
    "Compare tracking devices, GPS trackers, BLE tags, smart labels, cold chain monitoring and visibility platforms from verified global providers. Request quotes through Strategic Tracking.";
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "");
  const image = ogImage || DEFAULT_OG;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {url && <link rel="canonical" href={url} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={ogType} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
